// extracted by mini-css-extract-plugin
module.exports = {"title":"ResourceGridLayout_title__s8Ec8"};